var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-row",
                { attrs: { center: "" } },
                [
                  _c("div", { staticClass: "breadcrumb" }, [
                    _vm._v(" Abonnementen "),
                  ]),
                  _c("w-spacer"),
                  _c("w-select", {
                    staticClass: "mr",
                    attrs: { items: _vm.statusFilterItems },
                    model: {
                      value: _vm.filter,
                      callback: function ($$v) {
                        _vm.filter = $$v
                      },
                      expression: "filter",
                    },
                  }),
                  _c(
                    "w-button-bar",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Account info bekijken",
                              expression: "'Account info bekijken'",
                            },
                          ],
                          attrs: {
                            disabled: _vm.editDisabled,
                            to: _vm.infoLink,
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "eye" } })],
                        1
                      ),
                      _vm.hasPermission("companies.write")
                        ? _c(
                            "w-button",
                            {
                              attrs: {
                                disabled: _vm.editDisabled,
                                to: _vm.editLink,
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "pen" } })],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        { staticStyle: { "flex-grow": "1", "flex-shrink": "1" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _vm.isFetching ? _c("app-fetching-spinner-overlay") : _vm._e(),
              _c("w-data-table", {
                staticStyle: {
                  "flex-grow": "1",
                  height: "calc(100vh - 185px)",
                },
                attrs: {
                  items: _vm.filteredItems,
                  columns: _vm.columns,
                  "order-column": "id",
                  "order-direction": "",
                  "selected-items": _vm.selectedItems,
                  "column-resize-handle": "",
                },
                on: {
                  scroll: function ($event) {
                    return _vm.onScroll($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }